// extracted by mini-css-extract-plugin
export default {"spacing":"AccountSettingSkeleton_spacing__sKdKa","innerSpacing":"AccountSettingSkeleton_innerSpacing__tvx94"};